import Icon from '../components/Icon.vue'

Icon.register({
  inbox: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M567.9 243.9c4.5 6.7 8.1 18.6 8.1 26.6v0 129.5c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-129.5 0c0-8 3.6-19.9 8.1-26.6l105.7-158.5c7.9-11.8 25.8-21.4 39.9-21.4h268.6c14.2 0 32.1 9.6 39.9 21.4zM162.3 128l-85.3 128h123.1l32 64h112l32-64h123.1l-85.3-128h-251.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/inbox.js
// module id = 1484
// module chunks = 0